export const appConfig = {
  apiUrl: process.env.MICROSITE_HIGO_API_URL,
  bearerToken: process.env.MICROSITE_HIGO_API_BEARER_TOKEN,
  partnerBearerToken: process.env.MICROSITE_HIGO_PARTNER_API_BEARER_TOKEN,
  gtmContainerId: process.env.MICROSITE_GTM_CONTAINER_ID,
  version: process.env.REACT_APP_VERSION,
};
